export const POCKETBASE_URL = 'https://pb-nonosky.seraphsystems.com/';

// Nonosky Orders configuration
export const NONOSKY_ORDERS_CONFIG = {
  // Order statuses
  orderStatuses: [
    'DRAFT',
    'PENDING',
    'CONFIRMED',
    'IN_PROGRESS',
    'SHIPPED',
    'DELIVERED',
    'CANCELLED',
    'REFUNDED'
  ],
  
  // Quotation statuses
  quotationStatuses: [
    'DRAFT',
    'SENT',
    'ACCEPTED',
    'REJECTED',
    'EXPIRED',
    'CONVERTED'
  ],
  
  // Product types
  productTypes: [
    'PRODUCT',
    'SERVICE',
    'DIGITAL',
    'SUBSCRIPTION',
    'OTHER'
  ],
  
  // Default pagination
  defaultPageSize: 20,
  maxPageSize: 100,
  
  // Currency settings
  currency: {
    symbol: '$',
    code: 'USD',
    decimalPlaces: 2
  },
  
  // Auto-generation settings
  autoGeneration: {
    quotationNumberPrefix: 'COT',
    orderNumberPrefix: 'ORD',
    numberLength: 6
  }
};

// Dashboard configuration
export const DASHBOARD_CONFIG = {
  // Chart colors
  chartColors: [
    '#3B82F6', // blue
    '#10B981', // emerald
    '#F59E0B', // amber
    '#EF4444', // red
    '#8B5CF6', // violet
    '#06B6D4', // cyan
    '#84CC16', // lime
    '#F97316'  // orange
  ],
  
  // Refresh intervals (in milliseconds)
  refreshIntervals: {
    dashboard: 30000, // 30 seconds
    charts: 60000,    // 1 minute
    tables: 15000     // 15 seconds
  }
};

// Google Maps API Configuration
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCTWYXhN2RbdwTvC5_Z29EhWqdsG4OxbKQ'; // Replace with your actual API key

// Email API Configuration
// Use relative path for API route (works with any deployment platform)
export const EMAIL_API_URL = typeof window !== 'undefined' 
  ? '/api/send-email'  // Use relative path to API route
  : '/api/send-email';
